import { isClient } from '../utils';
/**
 * 漏斗打点类型枚举
 */
export var FunnelLogType;
(function (FunnelLogType) {
    /**
     * 源入口，如蹦蹦等
     */
    FunnelLogType["Source"] = "source";
    /**
     * 源入口中的点击事件，如点击蹦蹦中的广告按钮
     */
    FunnelLogType["SourceClick"] = "source-click";
    /**
     * 页面访问
     */
    FunnelLogType["PageView"] = "page-view";
    /**
     * 点击事件，如点击收银台中的支付按钮
     */
    FunnelLogType["Click"] = "click";
})(FunnelLogType || (FunnelLogType = {}));
/**
 * 是否为debug模式
 * 为真则上传打点日志时，会调用测试接口
 * 8888渠道默认开启debug模式
 */
export var $isDebug = isClient &&
    /^https?:\/\/(mobiletest|yktpre|mobilelan)\.emoney\.cn/.test(location.href);
/**
 * 设置debug模式
 * @param isDebug 是否开启debug模式
 */
export function $setDebug(isDebug) {
    if (isDebug === void 0) { isDebug = true; }
    $isDebug = isDebug;
}
export var $pageId = '';
export function $setPageId(pageId) {
    $pageId = pageId;
}
/**
 * 当前页面漏斗路径
 * @type {string}
 */
export var $sourcePath = '';
/**
 * 设置当前页面漏斗路径
 * @param sourcePath
 */
export function $setSourcePath(sourcePath) {
    $sourcePath = sourcePath;
}
export function $getSourcePath() {
    return $sourcePath;
}
//# sourceMappingURL=share.js.map